import React, { useRef, useEffect, useState } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css/navigation";
import { Navigation, Pagination } from "swiper/modules";
import "swiper/css";
import styles from "./ClientsSaySection.module.css";
import { ChevronLeft, ChevronRight } from "lucide-react";
import type { Swiper as SwiperType } from "swiper";
// List of video files in public/media (update as needed)
const clientVideos = ["/media/cl1.mp4", "/media/Ahmed.mp4", "/media/cl2.mp4"];

export default function ClientTestimonials() {
  const videoRefs = useRef<(HTMLVideoElement | null)[]>([]);
  const swiperRef = useRef<SwiperType | null>(null);
  const prevButtonRef = useRef<HTMLButtonElement>(null);
  const nextButtonRef = useRef<HTMLButtonElement>(null);
  // Remove 'activeSlide' and 'handleDotClick' if they are not used anywhere in the file.

  // Pause all videos when slide changes
  const handleSlideChange = (swiper: SwiperType) => {
    // setActiveSlide(swiper.realIndex); // This line is removed

    // Pause all videos and reset to beginning
    videoRefs.current.forEach((video, index) => {
      if (video) {
        video.pause();
        video.currentTime = 0;
      }
    });
  };

  // Handle dot navigation
  // const handleDotClick = (index: number) => { // This line is removed
  //   if (swiperRef.current) {
  //     swiperRef.current.slideTo(index);
  //   }
  // }; // This line is removed

  // Initialize - pause all videos on mount
  useEffect(() => {
    videoRefs.current.forEach((video) => {
      if (video) {
        video.pause();
        video.load();
      }
    });
  }, []);

  useEffect(() => {
    if (
      swiperRef.current &&
      prevButtonRef.current &&
      nextButtonRef.current &&
      swiperRef.current.params.navigation
    ) {
      // @ts-ignore
      swiperRef.current.params.navigation.prevEl = prevButtonRef.current;
      // @ts-ignore
      swiperRef.current.params.navigation.nextEl = nextButtonRef.current;
      swiperRef.current.navigation.destroy();
      swiperRef.current.navigation.init();
      swiperRef.current.navigation.update();
    }
  }, []);

  return (
    <section className={styles.section}>
      <div className={styles.container}>
        {/* Section Title */}
        <div className={styles.title}>
          <h2 className={styles.heading}>What Our Clients Say</h2>
          <p className={styles.subtitle}>
            Don't just take our word for it - hear directly from our satisfied
            clients
          </p>
        </div>

        {/* Video Carousel Container */}
        <div className={styles.carouselContainer}>
          <Swiper
            modules={[Navigation, Pagination]}
            spaceBetween={30}
            slidesPerView={1}
            centeredSlides={true}
            style={{ paddingBottom: 80 }}
            pagination={{ clickable: true }}
            loop={true}
            // Remove navigation prop here
            onInit={(swiper) => {
              swiperRef.current = swiper;
            }}
            onSlideChange={handleSlideChange}
            className={styles.testimonialSwiper}
          >
            {clientVideos.map((video, index) => (
              <SwiperSlide>
                <div className={styles.videoCard}>
                  <video
                    ref={(el) => {
                      videoRefs.current[index] = el;
                    }}
                    src={video}
                    poster={video}
                    controls
                    className={styles.video}
                    playsInline
                    preload="metadata"
                    controlsList="nodownload"
                  >
                    Your browser does not support the video tag.
                  </video>

                  {/* Video Overlay for Better UX */}
                  <div className={styles.videoOverlay} />
                </div>
              </SwiperSlide>
            ))}
          </Swiper>

          {/* Custom Navigation Buttons */}
          <button
            ref={prevButtonRef}
            className={`${styles.navButton} ${styles.prevButton}`}
            aria-label="Previous testimonial"
          >
            <ChevronLeft className={styles.navIcon} />
          </button>

          <button
            ref={nextButtonRef}
            className={`${styles.navButton} ${styles.nextButton}`}
            aria-label="Next testimonial"
          >
            <ChevronRight className={styles.navIcon} />
          </button>
        </div>
      </div>
    </section>
  );
}
